import { LitElement } from 'lit';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { DedupeMixin, wasApplied } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/dedupe.js';
export const CipublicMixin = (constructor) => {
    if (wasApplied(CipublicMixin, constructor)) {
        return constructor;
    }
    class Cipublic extends constructor {
        emit(name, options) {
            return emit(this, name, options);
        }
    }
    DedupeMixin(CipublicMixin, Cipublic);
    return Cipublic;
};
/**
 * Cipublic Base Class
 */
export class CipublicElement extends CipublicMixin(LitElement) {
}
//# sourceMappingURL=base.js.map